import { logger } from './logger';

export async function copyToClipboard(text: string) {
  try {
    await navigator.clipboard.writeText(text);
  } catch (err) {
    logger.error('Could not copy text: ', {}, err as Error);
  }
}
